import { useFormStore } from '@/stores/form'
import router from '@/router'
import lookups from '@/assets/json/clientLookups.json'
import { useGlobalStore } from '@/stores/global'
import axiosInstance from '@/services'

export default async function () {
  const formStore = useFormStore()
  const globalStore = useGlobalStore()
  const {
    serviceTransactionId,
    serviceConfig: { transactionId, isGoldenVisa, isUnifiedNumberOrFileNumberRequired },
    showConductIdentificationCodeCertificate,
    preferedLanguageId,
    englishApplicantName,
    arabicApplicantName,
    applicantMobile,
    applicantEmail,
    enableCompanionNumber,
    showVisitReason,
    optionalNominationRequestForServices,
    nominationRequestIds
  } = globalStore.startedService
  const {
    transactionReason,
    ServiceTransactions: {
      sixmonthsToFinalizeTheProceduresOfGoldenResidency,
      goldenResidencyVisaForHumanitarianPioneersIssue,
      decree28_PersonsWhoAreTalented,
      goldenResidenceScientistsandSpecialists,
      issueVisaForIndianNationalsWithSpecialVisas,
      foreignerRetiredOutsideUaeVisa,
      visaForUniversityGraduatesInsideUAE,
      visaForUniversityGraduatesOutsideUAE,
      issueResidencyVisaForExperiencedWorkersInsideUAE,
      issueResidencyVisaForFreelancersInsideUAE
    },
    gccNationalityId: { uae },
    draftStatus: { newDraft },
    companionNumberForVisa
  } = lookups
  const { refDraftId, applicationKey, withException, requestNumber, administrativeRegionId } =
    router.currentRoute.value.query
  formStore.extraMap = {
    ...formStore.extraMap,
    hideNominationInfoForSelectedReason: false,
    showOptionalNominationRequestForServices: false,
    showApplyByNomination: false,
    isDisable: false,
    isRequired: false,
    uaeWorkPhoneRequired: 'required',
    uaeWorkPhoneIsRequired: true,
    visaDuarationMsg: '',
    isBuildingNameRequired: 'required',
    showUniversities: false,
    serviceTransactionId,
    refDraftId,
    showEstablishmentDetails: false,
    isReadDataFromCard: serviceTransactionId == sixmonthsToFinalizeTheProceduresOfGoldenResidency,
    hideRetriveVisaInfoSection: true,
    isOpenRetriveVisaInfoSection: true,
    visaInfo: null,
    showAllSectionOnResponse: false,
    showAllSection: false,
    isUsingCardReader: false,
    isUsingSponsorEIDA: false,
    disableTransactionReasonId: false,
    serviceTransactionName: '',
    serviceDescription: '',
    isFaithRequired: true,
    transactionReason,
    isGoldenVisa,
    isReasonRequiresThreeSectionEstabNumber: false,
    enableNominationRequest: true,
    disabledIssuanceVisaEmirate: false,
    enableAnonymousUsersToRetrieveTheirVisaInfo: false,
    hidereCAPTCHA: false,
    showConductIdentificationCodeCertificate: false,
    isInCompleteDraftFlag: false,
    nominationRequestIds,
    isNominationRequestValid: false,
    showEducationCountry: false,
    showEducationDetails: false,
    exception: null,
    showVisitReason: false,
    isTheUnifiedNumberRequired: true,
    isIdentityNumberRequired: true,
    showCompanionNumber: false
  }

  formStore.extraMap.hideRetriveVisaInfoSection = requestNumber ? true : false
  formStore.extraMap.showEstablishmentDetails = [
    goldenResidencyVisaForHumanitarianPioneersIssue,
    decree28_PersonsWhoAreTalented,
    goldenResidenceScientistsandSpecialists
  ].includes(serviceTransactionId)

  if (applicationKey) {
    let res = await axiosInstance.request({
      url: `/api/entrepreneur/getEntrepreneurRequest/${applicationKey}`,
      method: 'GET'
    })
    if (res) {
      formStore.draft.request = {
        ...formStore.draft.request,
        ...res,
        dFFApplicationToken: res.applicationKey,
        investmentEmirateId: res.applicationEmirateId
      }
      formStore.draft = {
        ...formStore.draft,
        serviceTransactionId,
        administrativeRegionId: res.applicationEmirateId,
        withException: withException === 'true'
      }
      formStore.extraMap.disableTransactionReasonId = true
    }
  } else if (requestNumber) {
    let res = await axiosInstance.request({
      url: `/api/guest/visa/draft/requestNumber/${requestNumber}`,
      method: 'GET'
    })
    if (res) {
      formStore.draft = {
        ...formStore.draft,
        ...res
      }
      formStore.extraMap.isUsingSponsorEIDA = res.isUsingSponsorIdentityCard
      formStore.extraMap.isUsingCardReader = res.isIdentityScanned
    }
  } else if (serviceTransactionId) {
    formStore.draft = {
      ...formStore.draft,
      serviceTransactionId,
      withException: withException === 'true',
      administrativeRegionId
    }
  }

  if (formStore.extraMap.refDraftId) {
    formStore.form.setValues({
      englishApplicantName,
      arabicApplicantName,
      applicantMobile,
      applicantEmail,
      preferedLanguageId
    })
  }

  if (serviceTransactionId == issueVisaForIndianNationalsWithSpecialVisas) {
    formStore.form.setValues({
      currentNationalityId: 25
    })
    formStore.extraMap.isDisable = true
  }

  if (
    [
      foreignerRetiredOutsideUaeVisa,
      visaForUniversityGraduatesInsideUAE,
      visaForUniversityGraduatesOutsideUAE
    ].includes(serviceTransactionId)
  ) {
    formStore.extraMap = {
      ...formStore.extraMap,
      uaeWorkPhoneRequired: '',
      uaeWorkPhoneIsRequired: false,
      isBuildingNameRequired: ''
    }
  }

  if (serviceTransactionId == visaForUniversityGraduatesInsideUAE) {
    formStore.form.setValues({
      educationLevelCountryId: uae
    })
  }

  if (formStore.extraMap.visaInfo) {
    formStore?.form?.setValues({
      retriveVisaInfo: true
    })
  }
  if (optionalNominationRequestForServices?.filter((x) => x == serviceTransactionId)) {
    formStore.draft.showOptionalNominationRequestForServices = true
    formStore.draft.showApplyByNomination = true
  }
  const checkConductIdentificationCodeCertificate = async () => {
    const {
      dateOfBirth,
      currentNationalityId,
      passportNumber,
      passportTypeId,
      personUnifiedNumber
    } = formStore.draft.request

    formStore.draft.request.conductIdentificationCodeCertificate = null
    formStore.form.setFieldValue('conductIdentificationCodeCertificate', null)
    formStore.extraMap.showConductIdentificationCodeCertificate = false

    const hasIdentity =
      (currentNationalityId && passportNumber && passportTypeId) || personUnifiedNumber
    if (showConductIdentificationCodeCertificate && dateOfBirth && hasIdentity) {
      let params = {
        unifiedNumber: personUnifiedNumber,
        passportNumber,
        passportTypeId,
        currentNationalityId,
        dateOfBirth
      }
      let res = await axiosInstance.request({
        url: '/api/requestmaster/showConductIdentificationCodeCertificate',
        method: 'POST',
        data: params
      })

      if (res) {
        formStore.extraMap.showConductIdentificationCodeCertificate = res
      }
    }
  }

  const loadConfig = () => {
    if (showVisitReason) {
      formStore.draft.showVisitReason = showVisitReason
    }
    checkConductIdentificationCodeCertificate()
    formStore.extraMap.isTheUnifiedNumberRequired =
      isUnifiedNumberOrFileNumberRequired ||
      isGoldenVisa ||
      [
        visaForUniversityGraduatesInsideUAE,
        issueResidencyVisaForExperiencedWorkersInsideUAE,
        issueResidencyVisaForFreelancersInsideUAE
      ].includes(serviceTransactionId)

    formStore.extraMap.isIdentityNumberRequired = [
      issueResidencyVisaForExperiencedWorkersInsideUAE,
      issueResidencyVisaForFreelancersInsideUAE
    ].includes(serviceTransactionId)

    if (
      companionNumberForVisa.indexOf(parseInt(serviceTransactionId)) != -1 &&
      enableCompanionNumber &&
      transactionId == 9
    ) {
      formStore.extraMap.showCompanionNumber = true
    }
  }
  loadConfig()
}
